module.exports = __webpack_public_path__ + "static/media/google-pay-logo.1fa3a8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-pay-logo.png
// module id = 6162
// module chunks = 1